package com.merkost.handpass.api.enums

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class ImageStatus(val value: String) {
    @SerialName("pending") PENDING("pending"),
    @SerialName("approved") APPROVED("approved"),
    @SerialName("rejected") REJECTED("rejected"),
    @SerialName("needs_review") NEEDS_REVIEW("needs_review");

    companion object {
        fun fromString(value: String): ImageStatus =
            entries.find { it.value == value.lowercase() } ?: PENDING

        fun fromDbValue(value: String): ImageStatus = fromString(value)
    }
}
